export const ProgressBarFill = ({count, reviews}) => {
  return (
    <div
      className="absolute inset-y-0 bg-kj-gold border border-kj-gold rounded-full"
      style={{
        width: `calc(${count.count} / ${reviews.length} * 100%)`,
      }}
    />
  );
};
